import { ALL_SELF_SERVICE_STATUS } from 'constants/SelfServiceConstants';
import { isElementBefore } from 'utils/ArrayUtils';

export const isSelfServiceStatusBelow = (selfServiceStatus: string, referenceStatus: string): boolean =>
  isElementBefore(ALL_SELF_SERVICE_STATUS, selfServiceStatus, referenceStatus);
